import CustomInput from "../../../../components/UI/PageInput/CustomInput";
import SearchDropdown from "../../../../components/UI/PageInput/SearchDropdown";
import DateInput from "../../../../components/UI/PageInput/DateInput";
import CustomFileInput from "../../../../components/UI/PageInput/CustomFileInput";
import SelectedImagesBox from "../../../../components/expense/add/SelectedImagesBox";
import {
  positiveNumberValidation,
  phoneValidation,
  emailValidation,
  aadharNumberValidation,
  panNumberValidation,
} from "../../../../validations/formValidations";

const PersonalInfo = ({
  userSetup,
  register,
  errors,
  setValue,
  control,
  watch,
  id_proof,
  removeProfilePic,
  profile_pic,
  remove,
}) => {
  const { dob, gender_id } = watch();

  return (
    <div className="userInfoWrap mt-0">
      <h4 className="userInfoHeading">Personal Info</h4>
      <div className="flex gap-3 p-4">
        <div className="w-[50%]">
          <CustomInput
            type="text"
            name="full_name"
            labelText="Full Name *"
            placeholder="Enter"
            register={{
              ...register("full_name", {
                required: "Please Enter full name",
              }),
            }}
            error={errors.full_name}
          />
          <CustomInput
            type="text"
            name="mobile_number"
            labelText="Phone No. *"
            placeholder="Enter"
            register={{
              ...register("mobile_number", {
                required: "Please Enter phone no.",
                ...phoneValidation,
              }),
            }}
            error={errors.mobile_number}
          />
          <CustomInput
            type="number"
            name="salary"
            labelText="Salary *"
            placeholder="Enter"
            register={{
              ...register("salary", {
                required: "Please Enter a salary",
                ...positiveNumberValidation,
              }),
            }}
            error={errors.salary}
          />
          <CustomInput
            type="text"
            name="aadhar_card_number"
            labelText="Aadhar Card Number *"
            placeholder="Enter 12 digit Aadhaar number"
            register={{
              ...register("aadhar_card_number", aadharNumberValidation),
            }}
            error={errors.aadhar_card_number}
          />
          <SearchDropdown
            name="gender_id"
            label="Gender *"
            keyName="name"
            id="id"
            options={userSetup.genders}
            control={control}
            setValue={setValue}
            selectedVal={gender_id}
            error={errors.gender_id}
          />
          <CustomFileInput
            name="profile"
            placeholder="Profile Picture (jpg, png)"
            accept=".png, .jpg, image/png, image/jpeg"
            register={{
              ...register("profile"),
            }}
            multiple={false}
          />
          <SelectedImagesBox
            selectedImages={profile_pic}
            remove={removeProfilePic}
            setValue={setValue}
            name="profile"
          />
        </div>
        <div className="halfCol">
          <CustomInput
            type="text"
            name="email"
            labelText="Email *"
            placeholder="Enter"
            register={{
              ...register("email", {
                required: "Please Enter a email",
                ...emailValidation,
              }),
            }}
            error={errors.email}
          />
          <CustomInput
            type="text"
            name="alternate_phone_number"
            labelText="Alternate Phone No"
            placeholder="Enter"
            register={{
              ...register("alternate_phone_number", {
                ...phoneValidation,
              }),
            }}
            error={errors.alternate_phone_number}
          />
          <DateInput
            label="Date of birth *"
            name={"dob"}
            value={dob}
            setValue={setValue}
            register={{
              ...register("dob", {
                required: "Please Select date of birth",
              }),
            }}
            error={errors.dob}
            disableCurrentAndFutureDays={true}
          />
          <CustomInput
            type="text"
            name="bike_reg_number"
            labelText="Bike Registration Number"
            placeholder="Enter"
            register={{
              ...register("bike_reg_number"),
            }}
          />
          <CustomInput
            type="text"
            name="pan_card_number"
            labelText="Pan Card Number  *"
            placeholder="Enter"
            register={{
              ...register("pan_card_number", {
                required: "Please Enter a pan card number",
                ...panNumberValidation,
              }),
            }}
            error={errors.pan_card_number}
          />
          <CustomFileInput
            name="id_proofPic"
            placeholder="Id Proof (jpg, png)"
            accept=".png, .jpg, image/png, image/jpeg"
            register={{
              ...register("id_proofPic"),
            }}
            multiple={true}
          />
          <SelectedImagesBox
            selectedImages={id_proof}
            remove={remove}
            setValue={setValue}
            name="id_proofPic"
          />
        </div>
      </div>
    </div>
  );
};
export default PersonalInfo;
